module.exports = [{
      plugin: require('H:/p/gwi-paprotny-kunstmaler/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
